module.exports = __webpack_public_path__ + "img/ot.5f5451b0.png";